<template>
    <list class="m-0 p-0"
          v-model="news"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          :actions="actions"
          :sort-change="sortChange"
          :default-sort="{prop: sf, order: so === 'asc' ? 'ascending' : 'descending'}"
          :edit="(props) => $router.push({ name: 'NewsEdit', params: { id: props.row.$id } })"
          :remove="(props) => confirmAndDelete(props.row)"
          :search-query="query"
          search-enabled
          @search-change="searchInput"
          :title="$t('News Overview')"
    />
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import BaseList from '../BaseList'
  import List from '../../Components/BasicList'
  import { NewsRecord } from '@/store/models/News'
  import get from 'lodash/get'

  export default {
    name: 'NewsList',
    extends: BaseList,
    components: {
      List
    },
    data () {
      return {
        sf: 'createdAt',
        so: 'desc',
        columns: [
          { name: 'createdAt', text: 'Created at', sortable: 'custom', align: 'left', formatter: this.dateFormatter, minWidth: 150 },
          { name: 'title', text: 'Title', sortable: 'custom', align: 'left', minWidth: 300 },
          { name: 'createdBy', text: 'Created by', sortable: 'custom', formatter: this.userFormatter, align: 'left', minWidth: 150 },
          { name: 'visibility', text: 'Visibility', sortable: 'custom', formatter: this.visibilityFormatter, align: 'left', minWidth: 150 }
        ],
        actions: [
          { label: 'Add News', click: () => this.$router.push({ name: 'NewsCreate' }) }
        ]
      }
    },
    computed: {
      loading: () => NewsRecord.getters('loading'),
      news: () => NewsRecord.all(),
      ...mapState('pagination', {
        pagination: (pagination) => pagination.news
      })
    },
    async mounted () {
      this.query = this.$route.query.q
      await this.fetchCurrentPage()
    },
    async beforeDestroy () {
      await NewsRecord.deleteAll()
    },

    methods: {
      ...mapActions('pagination/news', ['paginate']),
      visibilityFormatter: function (row) {
        return row.type === 'team' ? this.$t('Team'): this.$t('Global')
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      userFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatUser(cellValue)
      },
      fetchCurrentPage: async function () {
        try {
          const newPage = parseInt(this.$route.query.page, 10) || 1
          await NewsRecord.dispatch('setLoading', true)
          const result = await NewsRecord.api().get('/news', {
            dataKey: 'items',
            params: Object.assign({ search: this.query, sf: this.sf, so: this.so, l: this.pagination.perPage, lo: newPage - 1 }),
            save: false
          })
          if (result.response && result.response.data && result.response.data.total) {
            this.paginate({
              perPage: this.pagination.perPage,
              currentPage: newPage,
              total: result.response.data.total
            })
          }
          await NewsRecord.create({ data: result.response.data.items })
        }
        catch (e) {
          this.$notify({ type: 'danger', title: 'Error fetching list.', message: e.message })
        }
        finally {
          await NewsRecord.dispatch('setLoading', false)
        }
      },
      confirmAndDelete (news) {
        this.$dialog.confirm(this.$t(`Confirm`), this.$t('Are you sure to delete {news}?', { news: news.title }), this.$t('Delete'))
          .then(async () => {
            await NewsRecord.api().delete(`/news/${news._id}`)
            await this.fetchCurrentPage()
          })
      },
      sortChange ({ column, prop, order }) {
        this.sf = prop || 'createdAt'
        this.so = (order || 'descending') === 'ascending' ? 'asc' : 'desc'
        this.fetchCurrentPage()
      }
    }
  }
</script>
